import axios from 'axios';

const apiClient = axios.create({
  baseURL: localStorage.getTurnCredentials,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
});

export default {
  getTurnCredentials(userId, roomId, token) {
    return apiClient.get(
      `${localStorage.turnCredentials}/turn-credentials/${userId}/${roomId}/${token}`
    );
  }
};
